<script lang="ts">
  export let klass: string = ""; // is-centered, is-right
</script>

<div class="tabs #{klass}">
  <ul>
    <slot />
  </ul>
</div>
